export default "__VITE_ASSET__Wud4_n3e__"